import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable, catchError } from "rxjs";
import { ResourceDto } from "src/app/core/dto/admin/resource.dto";
import {
    handleHttpError,
    httpOptions,
} from "src/app/core/helpers/app/http.util";

@Injectable({
    providedIn: "root",
})
export class ResourceService {
    private readonly http = inject(HttpClient);
    private readonly basePath = "/resources";

    getAll(): Observable<ResourceDto[]> {
        return this.http.get<ResourceDto[]>(`${this.basePath}/list`);
    }

    getById(id: number): Observable<ResourceDto> {
        return this.http.get<ResourceDto>(this.basePath, { params: { id } });
    }

    getByAssignmentToken(token: string): Observable<ResourceDto> {
        return this.http.get<ResourceDto>(
            `${this.basePath}/byAssignmentToken`,
            { params: { assignmentToken: token } },
        );
    }

    create(data: unknown): Observable<unknown> {
        return this.http
            .post(this.basePath, data, httpOptions)
            .pipe(catchError(handleHttpError("")));
    }

    update(id: number, data: unknown): Observable<unknown> {
        return this.http
            .put(this.basePath, data, {
                ...httpOptions,
                params: { id },
            })
            .pipe(catchError(handleHttpError("")));
    }

    delete(id: number): Observable<unknown> {
        return this.http
            .delete(this.basePath, {
                ...httpOptions,
                params: { id },
            })
            .pipe(catchError(handleHttpError("")));
    }
}
